import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { Concurso } from 'src/app/models/concurso'
import { ConcursoService } from 'src/app/services/concurso.service'

/**
 * Store de estado do concurso atualmente aberto nas abas.
 * Carrega dados UMA vez e compartilha entre todos os componentes filhos.
 * Evita chamadas HTTP duplicadas de concurso/{id}.
 *
 * Para campus/unidades-habilitadas, usar ConcursoService.camposHabilitados()
 * diretamente (já cacheado no service singleton).
 */
@Injectable()
export class ConcursoDetalheStore {
  private concursoSubject = new BehaviorSubject<Concurso | null>(null)
  private loadedId: number | null = null

  concurso$ = this.concursoSubject.asObservable()

  get concurso(): Concurso | null {
    return this.concursoSubject.value
  }

  constructor(private concursoService: ConcursoService) {}

  /**
   * Carrega o concurso. Se já carregou o mesmo ID, retorna do cache.
   */
  load(id: number): Observable<Concurso> {
    if (this.loadedId === id && this.concursoSubject.value) {
      return this.concurso$ as Observable<Concurso>
    }

    this.loadedId = id
    return this.concursoService.get(id).pipe(
      tap(concurso => this.concursoSubject.next(concurso))
    )
  }

  /**
   * Invalida o cache (ex: após salvar alterações no concurso).
   */
  invalidate(): void {
    this.loadedId = null
    this.concursoSubject.next(null)
  }
}
